import { render } from "./App.vue?vue&type=template&id=a928e86a&bindings={\"currentStep\":\"data\",\"lastStep\":\"data\",\"currentFloorName\":\"data\",\"nextStep\":\"options\",\"goToFloor\":\"options\",\"backToLift\":\"options\",\"goToHall\":\"options\",\"exit\":\"options\",\"backToStreet\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script